import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService, UserSignal } from '@app/services/auth.service';
import { StationService } from '@app/services/station.service';
import { UserService } from '@app/services/user.service';
import { GcImageComponent } from '../gc-image/gc-image.component';

@Component({
  selector: 'app-add-station-image-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    GcImageComponent,
  ],
  templateUrl: './add-station-image-dialog.component.html',
  styleUrl: './add-station-image-dialog.component.scss',
})
export class AddStationImageDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<AddStationImageDialogComponent>);
  state = signal<'initial' | 'loading' | 'success' | 'error'>('initial');

  newImages: string[] = [];
  imagePreviews: string[] = [];
  images: File[] = [];

  user = signal<UserSignal>(undefined);
  getUserPhoto = null;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private stationService: StationService,
    @Inject(MAT_DIALOG_DATA) public data: { stationId: number },
  ) {}

  ngOnInit(): void {
    this.user = this.authService.userSignal;
    this.getUserPhoto = this.userService.getUserPhoto;

    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close(this.newImages);
    });
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    Array.from(input.files).forEach((file) => {
      if (file.type.startsWith('image/')) {
        this.images.push(file);

        const reader = new FileReader();
        reader.onload = () => this.imagePreviews.push(reader.result as string);
        reader.readAsDataURL(file);
      }
    });
  }

  removeImage(img: any) {
    const index = this.imagePreviews.indexOf(img);
    this.imagePreviews.splice(index, 1);
    this.images.splice(index, 1);
  }

  async submitForm() {
    if (this.data.stationId === undefined) {
      console.error('Station ID is undefined');
      return;
    }

    this.state.set('loading');
    if (this.images.length > 0) {
      await this.stationService.addStationPhotos(
        this.data?.stationId,
        this.images,
      );
    }
    this.newImages = [...this.newImages, ...this.imagePreviews];
    this.images = [];
    this.imagePreviews = [];
    this.state.set('success');
  }

  close() {
    this.dialogRef.close(this.newImages);
  }
}
